// src/redux/features/Order/orderThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import OrderServices from "../../../services/orderServices";
import { clearItems } from "../Cart/cartSlice";

export const createOrder = createAsyncThunk(
  "createOrder",
  async (order, { dispatch, getState, rejectWithValue }) => {
    try {
      // ✅ تغییر از userLogin به auth
      const { auth } = getState();
      const userInfo = auth?.userInfo;

      if (!userInfo) {
        throw new Error("User not authenticated");
      }

      const response = await OrderServices.addOrderItems(order, {
        userInfo,
        dispatch,
      });
      dispatch(clearItems());
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ?? { message: error.message }
      );
    }
  }
);

export const getOrderDetails = createAsyncThunk(
  "getOrderDetails",
  async (orderId, { dispatch, getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const userInfo = auth?.userInfo;

      if (!userInfo) {
        throw new Error("User not authenticated");
      }

      const response = await OrderServices.getOrderById(orderId, {
        userInfo,
        dispatch,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ?? { message: error.message }
      );
    }
  }
);

export const getMyOrderList = createAsyncThunk(
  "getMyOrderList",
  async (_, { dispatch, getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const userInfo = auth?.userInfo;

      if (!userInfo) {
        throw new Error("User not authenticated");
      }

      const response = await OrderServices.getMyOrders({ userInfo, dispatch });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ?? { message: error.message }
      );
    }
  }
);